import { render, staticRenderFns } from "./SaveInfoRecommend.vue?vue&type=template&id=3b9da9d7&scoped=true"
import script from "./SaveInfoRecommend.vue?vue&type=script&lang=js"
export * from "./SaveInfoRecommend.vue?vue&type=script&lang=js"
import style0 from "./SaveInfoRecommend.vue?vue&type=style&index=0&id=3b9da9d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9da9d7",
  null
  
)

export default component.exports